import Card from '../Reusable/Card';
import { useForm } from 'react-hook-form';
import Button from '../Reusable/Button';
import { useEffect, useState } from 'react';
import Modal from '../Reusable/Modal';
import CreateUpdateKMRecord from './CreateUpdateKMRecord';
import NextPreviousMonth from './NextPreviousMonth';
import DataTable from './KMRecordDataTable';
import PriceField from '../Reusable/Form/PriceField';
import DateRangePicker from '../Reusable/DateRrangePicker';
import moment from 'moment';

const RiderKMRecord = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch
  } = useForm<any>({
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data,
      }
    }
  });
  const [openEditKMRecordPopup, setOpenEditKMRecordPopup] = useState(false)

  const { handleCreate, isPostLoading, kmRecord: { header, body }, setCurrentMonth, currentMonth, setRefetch, setCustomDateFiler } = props
  const [selectedRider, setSelectedRider] = useState(null)
  const [selectedDate, setSelectedDate] = useState<string | null>()

  const selectedDateRange = watch("created__range")
  useEffect(() => {

    if (selectedDateRange) {
      setCustomDateFiler({
        ...{
          start_date: selectedDateRange?.split(",")[0],
          end_date: selectedDateRange?.split(",")[1]
        }
      })
    } else {
      setCustomDateFiler({
        ...{
          start_date: null,
          end_date: null
        }
      })
    }
  }, [selectedDateRange])
  
  let defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Rider Name",
      accessorKey: "rider_name",
      cell: ({ row, getValue }: any) => (
        <div className='cursor-pointer'>
          <p className='whitespace-nowrap'>{getValue()}</p>
        </div>
      ),
    },

    {
      header: "Total KMs",
      accessorKey: "total_kms",
      cell: ({ row, getValue }: any) => (
        <div className='cursor-pointer'>
          <p className='whitespace-nowrap'>Distance: {row?.original?.total_distance} Kms</p>
          <p className='whitespace-nowrap'>Total Amount: NRs. {row?.original?.total_amount} </p>
        </div>
      ),
    },
  ];
  defaultColumns.splice(2, 0, ...header.map((item: string, index: number) => ({
    header: item,
    accessorKey: item,
    cell: ({ row, getValue }: any) => {
      let obj = row?.original?.attendance?.[index]?.[item]
      return (
        <div className='cursor-pointer' onClick={() => {
          setOpenEditKMRecordPopup(!openEditKMRecordPopup);
          setSelectedRider({ ...obj, rider: row?.original?.rider_id })
          setSelectedDate(item)
        }}>
          {obj ?
            <>
              <p className='whitespace-nowrap text-sm'>KM Record: {obj?.s_km ?? 0.00}-{obj?.e_km ?? 0.00}</p>
              <p className='whitespace-nowrap text-sm'>Distance: {obj?.travel_distance ?? 0.00}</p>
              <p className='whitespace-nowrap text-sm'>Rate: {obj?.rate ?? 0.00}</p>
              <p className='whitespace-nowrap text-sm'>Total Amount: {obj?.total_amount ?? 0.00} </p>
            </>
            : "N/A"}
        </div>
      )
    }
  })))

  return (
    <>
      <Card
        title="Settings"
      >
        <form onSubmit={handleSubmit((data: any) => handleCreate(data, setError))} autoComplete="off">
          <PriceField
            setValue={setValue}
            value={getValues().rate_per_km}
            clearErrors={clearErrors}
            label={"Today Rate Per KM"}
            register={register("rate_per_km")}
            errors={errors?.rate_per_km}
          />
          <div className="flex justify-end w-full">
            <div className="w-[100px] mr-4">
              <Button label={"Update"} isLoading={isPostLoading} />
            </div>
          </div>
        </form>
      </Card>
      <DataTable
        data={body}
        columns={defaultColumns}
        tableName={"KM Record"}
        actionMenu={
          <div className="flex w-full justify-between">
            <div className='mt-[-18px] w-full mr-4'>
              <DateRangePicker
                label={""}
                setValue={setValue}
                name={"created__range"}
                getValues={getValues}
              />
            </div>

            <NextPreviousMonth
              setCurrentMonth={setCurrentMonth}
              currentMonth={currentMonth}
              setRefetch={setRefetch}
            />
          </div>
        }
      />
      <Modal
        isOpen={openEditKMRecordPopup}
        setIsOpen={setOpenEditKMRecordPopup}
        title={"Create/Update KM Record"}
        children={<>
          <CreateUpdateKMRecord
            setOpenEditKMRecordPopup={setOpenEditKMRecordPopup}
            selectedRider={selectedRider}
            selectedDate={selectedDate}
          />
        </>}
      />
    </>

  )
}

export default RiderKMRecord
